import React, { useEffect, useState } from "react";
import { PartyPopper, Heart } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { foodApi } from "../../lib/api";

// Shows the active food launch-offer every time it mounts (home start page + checkout).
// Renders nothing while the offer is inactive (auto-hides after it ends).
export function LaunchOfferDialog() {
  const [offer, setOffer] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    foodApi.launchOffer().then((o) => { setOffer(o); if (o?.active) setOpen(true); }).catch(() => {});
  }, []);

  if (!offer?.active) return null;
  const percent = offer.percent || 10;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-md overflow-hidden rounded-3xl border-0 p-0" data-testid="launch-offer-dialog">
        <div className="bg-gradient-to-br from-brand to-coral-600 px-6 pb-7 pt-8 text-center text-white">
          <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-white/20">
            <PartyPopper className="h-7 w-7" />
          </div>
          <DialogHeader>
            <DialogTitle className="text-center text-2xl font-extrabold text-white" data-testid="launch-offer-title">
              {percent}% OFF every food order
            </DialogTitle>
            <DialogDescription className="mt-1 text-center text-sm text-white/90">
              Our launch celebration — the discount is applied automatically at checkout. No code needed.
            </DialogDescription>
          </DialogHeader>
        </div>
        <div className="px-6 pb-6 pt-5 text-center">
          <p className="flex items-center justify-center gap-1.5 text-sm font-semibold text-ink">
            <Heart className="h-4 w-4 fill-coral-500 text-coral-500" /> Thank you for being with KohimaTaxi &amp; Delivery
          </p>
          <p className="mt-1.5 text-xs text-ink-muted">
            Enjoy {percent}% off your food items on every order. {offer.ends_label ? `Offer ends ${offer.ends_label}.` : "Hurry — offer runs for a limited time."}
          </p>
          <Button onClick={() => setOpen(false)} className="mt-5 h-11 w-full rounded-full bg-brand text-sm font-bold text-white hover:bg-brand-600" data-testid="launch-offer-close">
            Explore food &amp; save
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
